import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';

import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { QMCategoryLink } from './qmcategorylink';

export class QMManual extends StarbaseEntity implements Serializable<QMManual> {
    public uid: number;
    public sourceReferenceUID: number;
    public createdDateTime: Date;
    public createdByUser: string;
    public lastModifiedByUser: string;
    public lastModifiedDateTime: Date;
    public specificationCategoryUIDs: QMCategoryLink[] = [];
    public itemName: string;
    public specifications: string;
    public editable: boolean;
    public qM_Links: Object[];

    // unmapped properties for display purposes.
    public saniSpecifications: string;
    public page: number;

    constructor() {
        super();
    }

    deserialize(input) {
        return Object.assign(new QMManual(), input);
    }
}
